import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useRefreshTokenMutation } from 'app/auth/api/auth-api';
import EnterOtp from 'components/Otp/EnterOtp/EnterOtp';
import { useAppDispatch } from 'hooks/useAppDispatch';
import useAppLanguage from 'hooks/useAppLanguage';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { activateSmsOtp, sendSmsOtpPin } from 'store/otp/otp-actions';
import { setActivateSmsOtpError } from 'store/otp/otp-slice';
import { RootState } from 'store/reducer';
import { useGetProfileQuery } from 'store/slices/profile-api';
import { EVENTS, SIGNUP_STEPS, trackEvent } from 'utils/analytics';
import { OTP_LENGTH, otpProcesses } from 'utils/constants';
import messages from '../../messages';

export const Route = createFileRoute('/auth/signup/_layout/otp')({
  component: Otp,
});

function Otp() {
  const dispatch = useAppDispatch();
  const language = useAppLanguage();

  const [refreshToken] = useRefreshTokenMutation();
  const { smsOtpActivationSuccess, loading, activateSmsOtpError } = useSelector(
    (rootState: RootState) => rootState.otp,
  );

  const navigate = useNavigate();
  const { data: profileData } = useGetProfileQuery();

  const sendOtp = () => {
    // TODO: can we just change the endpoint to accept a single number? Otherwise we have to somehow split it there
    dispatch(sendSmsOtpPin(otpProcesses.SIGNUP_ENABLE_SMS_OTP));
  };

  const otpMessages = messages[language]?.otp;

  const onChangeOtp = async (otp: string) => {
    if (otp.length >= OTP_LENGTH)
      dispatch(activateSmsOtp(otp, otpProcesses.SIGNUP_ENABLE_SMS_OTP));
    if (otp.length < 6) dispatch(setActivateSmsOtpError(false));
  };

  useEffect(() => {
    if (smsOtpActivationSuccess) {
      refreshToken();
      trackEvent(EVENTS.REGISTER, {
        step: SIGNUP_STEPS.OTP,
        userId: profileData?.id ?? undefined,
      });

      navigate({ from: Route.fullPath, to: '../tos' });
    }
  }, [smsOtpActivationSuccess]);

  useEffect(() => {
    const removeOtpError = () => {
      dispatch(setActivateSmsOtpError(false));
    };
    return () => removeOtpError();
  }, []);

  return (
    <>
      <div className="flex justify-center items-center flex-col mb-8">
        <EnterOtp
          title={otpMessages.title}
          subtitle={otpMessages.subtitle(profileData?.msisdn)}
          onChangeOtp={onChangeOtp}
          resendOtp={() => sendOtp()}
          darkText
          hasError={activateSmsOtpError}
          isLoading={loading}
          type="SMS"
          hasSkip
          onSkip={() => navigate({ from: '/auth/signup/otp', to: '../tos' })}
          process={otpProcesses.SIGNUP_ENABLE_SMS_OTP}
        />
      </div>
    </>
  );
}
